import "ckeditor5/ckeditor5.css";
import fetchTranslation from "../src/ckeditor/easy_editor/utils/fetchTranslation";
import { generateCkeCustomColorsCss } from "../src/ckeditor/font_color/customFontColorCssGenerator";

generateCkeCustomColorsCss();

window.EasyEditor = window.EasyEditor || {};
window.EasyEditor.initEditor = async config => {
  await import("../src/ckeditor/ckeditor");
  await fetchTranslation(config.language || window.EASY.CKEditorDefaultConfig.language);
  return await window.EasyEditor.initEditor(config);
};
